import { UseIncidentsPageResultIProps } from '../hooks/useIncidentsPage'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box as ChakraBox } from '@chakra-ui/react'

import { DarkProvider, Flex, Text, TopBar } from '@hivewatch/dark'

import { DarkActionButtons } from '@/components/layouts/ActionButtons'
import { EditModeFrame } from '@/components/layouts/EditMode'

import { DarkIncidentsTable } from '../dark-incidents-table'
import { DarkIncidentsSearchFilterHeader } from './DarkIncidentsSearchFilterHeader'

const TOP_BAR_HEIGHT = '64px'

export const DarkIncidentsPage = ({
  incidentList,
  totalIncidents,
  hasLoadedOnce,
  isTableLoading,
  paginationState,
  setPaginationState,
  sorting,
  setSorting,
  rowSelection,
  setRowSelection,
  queryFilter,
  setQueryFilter,
  isPriorityQueueActive,
  incidentsView,
  onSelectView,
}: UseIncidentsPageResultIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const pageBg = colorScheme === 'light' ? 'light.bg.app' : 'bg.app'
  const shouldShowTable = isTableLoading || incidentList.length > 0

  return (
    <DarkProvider>
      <ChakraBox display='flex' flexDirection='column' height='100vh'>
        <TopBar
          actions={<DarkActionButtons />}
          colorScheme={colorScheme}
          dataTestId='incidentsPage_header'
          items={[
            {
              label: t('incidents:page_title'),
              count: totalIncidents,
              loading: !hasLoadedOnce,
            },
          ]}
        />
        <ChakraBox
          h={`calc(100vh - ${TOP_BAR_HEIGHT})`}
          mx='auto'
          pos='relative'
          w='full'
        >
          <EditModeFrame />
          <Flex bg={pageBg} direction='column' h='100%'>
            <DarkIncidentsSearchFilterHeader
              colorScheme={colorScheme}
              filter={queryFilter}
              incidentsView={incidentsView}
              onSelectView={onSelectView}
              setFilter={setQueryFilter}
            />
            <ChakraBox flex='1' minH={0} overflow='hidden' px={6} py={4}>
              {shouldShowTable ? (
                <DarkIncidentsTable
                  incidents={incidentList}
                  isLoading={isTableLoading}
                  isPriorityQueueActive={isPriorityQueueActive}
                  paginationState={paginationState}
                  rowSelection={rowSelection}
                  setPaginationState={setPaginationState}
                  setRowSelection={setRowSelection}
                  setSorting={setSorting}
                  sorting={sorting}
                  totalIncidents={totalIncidents}
                />
              ) : (
                <Flex align='center' h='100%' justify='center'>
                  <Text
                    color={
                      colorScheme === 'light'
                        ? 'light.text.secondary'
                        : 'text.secondary'
                    }
                  >
                    {t('common:list_empty')}
                  </Text>
                </Flex>
              )}
            </ChakraBox>
          </Flex>
        </ChakraBox>
      </ChakraBox>
    </DarkProvider>
  )
}
